import { render, staticRenderFns } from "./SolicitudesFechaMatriculaListado.vue?vue&type=template&id=70735647"
import script from "./SolicitudesFechaMatriculaListado.vue?vue&type=script&lang=js"
export * from "./SolicitudesFechaMatriculaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports